import React, { useState } from 'react';
import OrderItem from './OrderItem';

const OrdersPanel = ({ orders, onUpdateOrderStatus }) => {
  const [filter, setFilter] = useState('todos');

  const filteredOrders = filter === 'todos' 
    ? orders 
    : orders.filter(order => order.status === filter);

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-bold text-gray-800">Pedidos Recientes</h3>
        <div>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="border border-gray-300 rounded-lg px-3 py-1 text-sm focus:ring-2 focus:ring-green-500"
          >
            <option value="todos">Todos</option>
            <option value="pendiente">Pendientes</option>
            <option value="en_proceso">En proceso</option>
            <option value="completado">Completados</option>
          </select>
        </div>
      </div>

      <div className="space-y-3">
        {filteredOrders.length > 0 ? (
          filteredOrders.map(order => (
            <OrderItem
              key={order.id}
              order={order}
              onUpdateStatus={onUpdateOrderStatus}
            />
          ))
        ) : (
          <p className="text-center text-gray-500 py-4">No hay pedidos</p>
        )}
      </div>
    </div>
  );
};

export default OrdersPanel;